module.exports = __webpack_public_path__ + "img/spooky_cointreasure.33648ae.png";